import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    TextField,
  } from "@mui/material";
  import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
  import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
  import dayjs from "dayjs";
  
  export const getInputBox = (
    label,
    value,
    onChange,
    disabled = false,
    type = "text",
    error = false,
    errorMsg = ""
  ) => {
    return (
      <>
        <FormControl size="small" fullWidth margin="dense">
          <TextField
            size="small"
            label={label}
            disabled={disabled}
            type={type}
            value={value || ""}
            error={error}
            onChange={onChange}
          />
        </FormControl>
        <FormHelperText error={error} margin="dense">
          {errorMsg}
        </FormHelperText>
      </>
    );
  };
  
  export const getDateInput = (
    label,
    value,
    onChange,
    disabled = false,
    openTo = "day",
    views = ["year", "day"],
    disableFuture = false,
    disableHighlightToday = false
  ) => {
    return (
      <FormControl size="small" fullWidth>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            clearable
            disabled={disabled}
            disableFuture={disableFuture}
            openTo={openTo}
            views={views}
            disableHighlightToday={disableHighlightToday}
            label={label}
            value={value ? dayjs(value) : null}
            onChange={onChange}
            slotProps={{ textField: { size: "small" } }}
          />
        </LocalizationProvider>
      </FormControl>
    );
  };
  
  export const getDropDown = (
    label,
    value,
    onChange,
    dropDownList,
    disabled = false
  ) => {
    return (
      <FormControl
        size="small"
        fullWidth
        margin="dense"
        // sx={{ maxWidth: "180px !important" }}
      >
        <InputLabel>{label}</InputLabel>
        <Select
          size="small"
          disabled={disabled}
          label={label}
          value={value || ""}
          onChange={onChange}
        >
          {dropDownList?.map((c, i) => {
            return (
              <MenuItem key={i} value={c.childID}>
                <span title={c.childName}>{c.childName}</span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };
  